<template>
  <q-list dense>
    <q-item
      v-for="(value, key) in list"
      :key="key"
      v-ripple="!disable"
      tag="label"
      :disable="disable"
      class="checklist-item"
    >
      <q-item-section
        v-if="withIcon && value[optionIcon]"
        side
      >
        <q-icon :name="value[optionIcon]" />
      </q-item-section>
      <q-item-section>
        <slot v-bind="value" />
      </q-item-section>
      <q-item-section side>
        <q-checkbox
          :disable="disable"
          :model-value="selected"
          :val="value[optionValue]"
          @update:model-value="(val) => $emit('selected', val)"
        />
      </q-item-section>
    </q-item>
    <q-item v-if="canSelectAll && !disable">
      <q-item-section />
      <q-item-section side>
        <div class="flex">
          <q-btn
            flat
            no-caps
            size="12px"
            label="Unselect All"
            color="orange-8"
            @click="unselectAll"
          />
          <q-btn
            flat
            no-caps
            size="12px"
            label="Select All"
            color="blue"
            class="q-ml-sm"
            @click="selectAll"
          />
        </div>
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
export default {
  props: {
    selected: {
      type: Array,
      default: () => {
        return []
      }
    },
    list: {
      type: Array,
      required: true
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    optionIcon: {
      type: String,
      default: 'icon'
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    withIcon: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    canSelectAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selected'],
  data () {
    return {
      newValue: ''
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  },
  methods: {
    selectAll () {
      for (const ele in this.list) {
        const value = this.list[ele][this.optionValue]
        if (!this.selected.includes(value)) {
          this.selected.push(value)
        }
      }
    },
    unselectAll () {
      this.selected.splice(0, this.selected.length)
    }
  }
}
</script>

<style scoped lang="scss">
.checklist-item {
  min-height: 20px;
  padding: 0px 16px;
}
</style>
